import { forwardRef } from 'react';
import MuiNotificationsIcon from '@mui/icons-material/Notifications';
import type { SvgIconProps } from '@mui/material';

const NotificationsIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => <MuiNotificationsIcon ref={ref} {...props} />
);

export default NotificationsIcon;
